import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Página não encontrada"
        description="A página que você está procurando não foi encontrada no Boardverso."
      />
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-5xl font-bold text-indigo-600 mb-6">404</h1>
        <h2 className="text-3xl font-semibold mb-4">Página não encontrada</h2>
        <p className="text-xl text-gray-600 mb-8">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link 
            to="/" 
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Voltar para a Página Inicial
          </Link>
          <Link 
            to="/search" 
            className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Buscar Jogos
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage; 